import React from 'react';
import { Link } from 'react-router-dom';

const Unauthorized = () => {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-gray-100 p-4">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-red-600 mb-6">Accès Refusé</h2>
        <p className="text-gray-500 mb-8">Désolé, vous n'avez pas les droits nécessaires pour accéder à cette page.</p>
        <Link
          to="/"
          className="bg-axa-blue-400 text-white px-6 py-3 rounded-md text-lg font-semibold hover:bg-blue-700 transition duration-300"
        >
          Retour à l'Accueil
        </Link>
      </div>
    </div>
  );
};

export default Unauthorized;
